import { render, staticRenderFns } from "./identity-authentication.vue?vue&type=template&id=55b8d668&scoped=true"
import script from "./identity-authentication.vue?vue&type=script&lang=js"
export * from "./identity-authentication.vue?vue&type=script&lang=js"
import style0 from "./identity-authentication.vue?vue&type=style&index=0&id=55b8d668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b8d668",
  null
  
)

export default component.exports